<template>
  <b-card class="message">
    <div class="text-center">
      <b-spinner></b-spinner>
      <p>Actualisation en cours...</p>
    </div>
  </b-card>
</template>

<script>
/**
 * @file       Comment loading component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {};
</script>

<style lang="scss" scoped></style>
